if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }


      /*
       * ---------------------------------------------------------
       * TTC ARTWORK CHECK
       * ---------------------------------------------------------
       */

getArtworkCheckVariantId(selection) {
  if (!selection) {
    return null;
  }

  const normalisedSelection = String(selection)
    .replace(/&amp;/gi, '&')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  if (normalisedSelection.startsWith('check my file')) {
    return 63364814373194;
  }

  if (normalisedSelection.startsWith('check & help')) {
    return 63364968317258;
  }

  return null;
}


      createArtworkCheckLinkId() {
        return (
          'ttc_' +
          Date.now().toString(36) +
          '_' +
          Math.random().toString(36).substring(2, 9)
        );
      }


      async addArtworkCheckService(
        serviceVariantId,
        serviceName,
        linkId,
        mainVariantId
      ) {
        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';

        const body = {
          items: [
            {
              id: Number(serviceVariantId),

              /*
               * Artwork Check must ALWAYS be quantity 1.
               */
              quantity: 1,

              properties: {
                '_artwork_check_link': linkId,
                '_artwork_check_service': serviceName,
                '_parent_variant_id': String(mainVariantId)
              }
            }
          ]
        };


        /*
         * Ask Shopify to return freshly-rendered cart sections
         * after adding the Artwork Check.
         */
        if (this.cart) {
          body.sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id);

          body.sections_url = window.location.pathname;
        }


        config.body = JSON.stringify(body);


        console.log(
          'TTC Artwork Check: adding service',
          {
            serviceName: serviceName,
            variantId: serviceVariantId,
            quantity: 1,
            linkId: linkId
          }
        );


        const response = await fetch(
          `${routes.cart_add_url}`,
          config
        );


        const responseData = await response.json();


        console.log(
          'TTC Artwork Check: Shopify response',
          responseData
        );


        if (!response.ok || responseData.status) {
          throw new Error(
            responseData.description ||
            responseData.message ||
            'Artwork Check could not be added.'
          );
        }


        return responseData;
      }


      /*
       * ---------------------------------------------------------
       * PRODUCT SUBMISSION
       * ---------------------------------------------------------
       */

      async onSubmitHandler(evt) {
        evt.preventDefault();


        if (
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }


        this.handleErrorMessage();


        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );


        this.submitButton.classList.add(
          'loading'
        );


        const loadingSpinner =
          this.querySelector('.loading__spinner');


        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }


        /*
         * -----------------------------------------------------
         * PREPARE NORMAL DAWN / APO FORM DATA
         * -----------------------------------------------------
         */

        const config =
          fetchConfig('javascript');


        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';


        /*
         * IMPORTANT:
         *
         * Keep FormData rather than converting the main
         * product request to JSON.
         *
         * APO may be supplying file uploads and other
         * properties that need multipart FormData.
         */
        delete config.headers[
          'Content-Type'
        ];


        const formData =
          new FormData(
            this.form
          );


        const mainVariantId =
          formData.get('id');


        /*
         * -----------------------------------------------------
         * READ APO "FILE CHECK" DIRECTLY FROM THIS FORM
         * -----------------------------------------------------
         *
         * APO outputs:
         *
         * name="File check"
         *
         * with one of:
         *
         * Print Ready
         * Check My File
         * Check & Help
         */

        const artworkCheck =
  formData.get('properties[File check]') ||
  formData.get('File check') ||
  this.form.querySelector(
    'input[name="properties[File check]"]:checked'
  )?.value ||
  this.form.querySelector(
    'input[name="File check"]:checked'
  )?.value ||
  'Not needed';


        console.log(
          'TTC Artwork Check selected:',
          artworkCheck
        );


        const artworkCheckVariantId =
          this.getArtworkCheckVariantId(
            artworkCheck
          );


        console.log(
          'TTC Artwork Check variant:',
          artworkCheckVariantId
        );


        /*
         * Only paid Artwork Check options receive a link ID.
         *
         * Print Ready returns null above, so no additional
         * Shopify product is added.
         */

        const artworkCheckLinkId =
          artworkCheckVariantId
            ? this.createArtworkCheckLinkId()
            : null;


        /*
         * -----------------------------------------------------
         * LINK MAIN PRINT PRODUCT TO ARTWORK SERVICE
         * -----------------------------------------------------
         */

        if (artworkCheckLinkId) {
          formData.append(
            'properties[_artwork_check_link]',
            artworkCheckLinkId
          );
        }


        /*
         * -----------------------------------------------------
         * REQUEST NORMAL DAWN CART SECTIONS
         * -----------------------------------------------------
         */

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );


          formData.append(
            'sections_url',
            window.location.pathname
          );


          this.cart.setActiveElement(
            document.activeElement
          );
        }


        config.body = formData;


        let mainProductResponse = null;
        let finalCartResponse = null;


        try {

          /*
           * ---------------------------------------------------
           * STEP 1:
           * ADD THE NORMAL PRINTING PRODUCT
           * ---------------------------------------------------
           */

          const response =
            await fetch(
              `${routes.cart_add_url}`,
              config
            );


          mainProductResponse =
            await response.json();


          /*
           * ---------------------------------------------------
           * NORMAL SHOPIFY / DAWN ERROR HANDLING
           * ---------------------------------------------------
           */

          if (mainProductResponse.status) {
            publish(
              PUB_SUB_EVENTS.cartError,
              {
                source: 'product-form',

                productVariantId:
                  mainVariantId,

                errors:
                  mainProductResponse.errors ||
                  mainProductResponse.description,

                message:
                  mainProductResponse.message
              }
            );


            this.handleErrorMessage(
              mainProductResponse.description
            );


            const soldOutMessage =
              this.submitButton.querySelector(
                '.sold-out-message'
              );


            if (soldOutMessage) {
              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );


              this.submitButtonText.classList.add(
                'hidden'
              );


              soldOutMessage.classList.remove(
                'hidden'
              );
            }


            this.error = true;

            return;
          }


          /*
           * Main product was added successfully.
           */
          finalCartResponse =
            mainProductResponse;


          /*
           * ---------------------------------------------------
           * STEP 2:
           * ADD ARTWORK CHECK AS A SEPARATE PRODUCT × 1
           * ---------------------------------------------------
           */

          if (artworkCheckVariantId) {
            try {
              finalCartResponse =
                await this.addArtworkCheckService(
                  artworkCheckVariantId,
                  artworkCheck,
                  artworkCheckLinkId,
                  mainVariantId
                );


              console.log(
                'TTC Artwork Check successfully added:',
                artworkCheck
              );

            } catch (artworkError) {

              console.error(
                'TTC Artwork Check failed:',
                artworkError
              );


              /*
               * The main printing product has already been
               * successfully added.
               *
               * Show the customer an error rather than silently
               * pretending the Artwork Check was added.
               */

              this.handleErrorMessage(
                'Your printing was added to the basket, but we could not add the Artwork Check. Please try again.'
              );


              finalCartResponse =
                mainProductResponse;
            }
          }


          /*
           * ---------------------------------------------------
           * NORMAL DAWN CART BEHAVIOUR
           * ---------------------------------------------------
           */

          if (!this.cart) {
            window.location =
              window.routes.cart_url;

            return;
          }


          const startMarker =
            CartPerformance.createStartingMarker(
              'add:wait-for-subscribers'
            );


          if (!this.error) {
            await publish(
              PUB_SUB_EVENTS.cartUpdate,
              {
                source:
                  'product-form',

                productVariantId:
                  mainVariantId,

                cartData:
                  finalCartResponse
              }
            );


            CartPerformance.measureFromMarker(
              'add:wait-for-subscribers',
              startMarker
            );
          }


          this.error = false;


          const quickAddModal =
            this.closest(
              'quick-add-modal'
            );


          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(
                  () => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(
                          finalCartResponse
                        );
                      }
                    );
                  }
                );
              },
              {
                once: true
              }
            );


            quickAddModal.hide(
              true
            );

          } else {

            CartPerformance.measure(
              'add:paint-updated-sections',
              () => {
                this.cart.renderContents(
                  finalCartResponse
                );
              }
            );

          }

        } catch (e) {

          console.error(
            'TTC Product Form Error:',
            e
          );


          this.handleErrorMessage(
            'Something went wrong while adding your order to the basket. Please try again.'
          );

        } finally {

          /*
           * ---------------------------------------------------
           * RESET BUTTON / LOADING STATE
           * ---------------------------------------------------
           */

          this.submitButton.classList.remove(
            'loading'
          );


          if (
            this.cart &&
            this.cart.classList.contains(
              'is-empty'
            )
          ) {
            this.cart.classList.remove(
              'is-empty'
            );
          }


          if (!this.error) {
            this.submitButton.removeAttribute(
              'aria-disabled'
            );
          }


          if (loadingSpinner) {
            loadingSpinner.classList.add(
              'hidden'
            );
          }


          CartPerformance.measureFromEvent(
            'add:user-action',
            evt
          );

        }
      }


      /*
       * ---------------------------------------------------------
       * EXISTING DAWN ERROR MESSAGE
       * ---------------------------------------------------------
       */

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) {
          return;
        }


        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );


        if (!this.errorMessageWrapper) {
          return;
        }


        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );


        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );


        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }


      /*
       * ---------------------------------------------------------
       * EXISTING DAWN SUBMIT BUTTON
       * ---------------------------------------------------------
       */

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );


          if (text) {
            this.submitButtonText.textContent =
              text;
          }

        } else {

          this.submitButton.removeAttribute(
            'disabled'
          );


          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }


      /*
       * ---------------------------------------------------------
       * VARIANT ID
       * ---------------------------------------------------------
       */

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}